import core from '~/core/scripts';
import './index.styl';
import React from 'react';
import ReactDOM from 'react-dom';
import Utils from '~/core/scripts/utils';
import YouDrawItWidget from '~/core/scripts/widgets/YouDrawItWidget';

if (module.hot) {
  // we only want HMR enabled for stylus files
  module.hot.accept(/\.styl$/);
}

core.init();

// this is just for development purposes -> if we are looking at a layout-sample,
// we check if there is a corresponding js file
if (process.env.NODE_ENV === 'development') {
  require('file-loader!./index.html');

  if (location.pathname.includes('.html')) {
    const fileToLoad = location.pathname.replace('.html', '.js');
    try {
      require(`./layout-samples${fileToLoad}`);
    } catch(e) {
      console.log(`[Starterit] no file found ${fileToLoad}`);
    }
  }
}

const ydiContainer = document.getElementById('einwohner');

let progress = [];

function trackProgress(index) {
  progress.push(index);
  progress = [...new Set(progress)];

  if (progress.length === 5) {
    Utils.trackEvent('user_complete_all', null, 'class_B');
    progress = [];
  }
}

if (ydiContainer) {
  ReactDOM.render((
    <YouDrawItWidget
      chartId="zukunftsrauschen__einwohner"
      dataVisibleIndex={5}
      data={[
        { x: 2000, y: 1187 },
        { x: 2001, y: 1188 },
        { x: 2002, y: 1188 },
        { x: 2003, y: 1184 },
        { x: 2004, y: 1180 },
        { x: 2005, y: 1177 },
        { x: 2006, y: 1170 },
        { x: 2007, y: 1164 },
        { x: 2008, y: 1156 },
        { x: 2009, y: 1149 },
        { x: 2010, y: 1142 },
        { x: 2011, y: 1120 },
        { x: 2012, y: 1115 },
        { x: 2013, y: 1108 },
        { x: 2014, y: 1107 },
        { x: 2015, y: 1119 },
        { x: 2016, y: 1114 },
        { x: 2017, y: 1111 }
      ]}
      xAxis={[2000, 2002, 2004, 2006, 2008, 2010, 2012, 2014, 2016, 2017]}
      yAxis={[1050, 1100, 1150, 1200, 1250, 1300]}
      yDecimals={0}
      margin={{top: 0, right: 12, bottom: 0, left: 12}}
      shareTitle="Einwohnerentwicklung im Sauerland"
      onCompleted={() => {
        document.getElementById('youdrawit_answer-1').classList.add('active');
        trackProgress(1);
      }}
    />
  ), ydiContainer);
}

const ydiContainer2 = document.getElementById('studierende');
if (ydiContainer2) {
  ReactDOM.render((
    <YouDrawItWidget
      chartId="zukunftsrauschen__studierende"
      dataVisibleIndex={5}
      data={[
        { x: 2002, y:  2.544 },
        { x: 2003, y:  3.114 },
        { x: 2004, y: 3.685 },
        { x: 2005, y:  4.126 },
        { x: 2006, y: 4.772 },
        { x: 2007, y:  5.318 },
        { x: 2008, y: 6.036 },
        { x: 2009, y: 6.671 },
        { x: 2010, y: 7.308 },
        { x: 2011, y: 7.953 },
        { x: 2012, y: 9.724 },
        { x: 2013, y: 11.272 },
        { x: 2014, y: 12.308 },
        { x: 2015, y: 13.619 },
        { x: 2016, y: 14.761 },
        { x: 2017, y: 15.234 },
        { x: 2018, y: 14.522 }
      ]}
      xAxis={[
        { value: 2002, label: 'WS 01/02' },
        { value: 2004, label: 'WS 03/04' },
        { value: 2006, label: 'WS 05/06' },
        { value: 2008, label: 'WS 07/08' },
        { value: 2010, label: 'WS 09/10' },
        { value: 2012, label: 'WS 11/12' },
        { value: 2014, label: 'WS 13/14' },
        { value: 2016, label: 'WS 15/16' },
        { value: 2018, label: 'WS 17/18' }
      ]}
      yAxis={[0, 4.000, 8.000, 12.000, 16.000, 20.000]}
      yDecimals={1}
      margin={{top: 0, right: 12, bottom: 0, left: 12}}
      linecolor="#2DCEB2"
      shareTitle="Studierende im Sauerland"
      onCompleted={() => {
        document.getElementById('youdrawit_answer-2').classList.add('active');
        trackProgress(2);
      }}
    />
  ), ydiContainer2);
}

const ydiContainer3 = document.getElementById('tourismus');

if (ydiContainer3) {
  ReactDOM.render((
    <YouDrawItWidget
      chartId="zukunftsrauschen__tourismus"
      dataVisibleIndex={5}
      data={[
        { x: 2000, y: 6131 },
        { x: 2001, y: 6148 },
        { x: 2002, y: 6022 },
        { x: 2003, y: 5901 },
        { x: 2004, y: 5997 },
        { x: 2005, y: 5897 },
        { x: 2006, y: 5879 },
        { x: 2007, y: 5913 },
        { x: 2008, y: 5979 },
        { x: 2009, y: 5829 },
        { x: 2010, y: 5855 },
        { x: 2011, y: 6076 },
        { x: 2012, y: 6181 },
        { x: 2013, y: 6156 },
        { x: 2014, y: 6191 },
        { x: 2015, y: 6303 },
        { x: 2016, y: 6500 },
        { x: 2017, y: 6813 }
      ]}
      xAxis={[2000, 2002, 2004, 2006, 2008, 2010, 2012, 2014, 2016, 2017]}
      yAxis={[5100, 5500, 5900, 6300, 6700, 7100]}
      yDecimals={0}
      margin={{top: 0, right: 12, bottom: 0, left: 12}}
      linecolor="#FF7575"
      shareTitle="Torismus im Sauerland"
      onCompleted={() => {
        document.getElementById('youdrawit_answer-3').classList.add('active');
        trackProgress(3);
      }}
    />
  ), ydiContainer3);
}

const ydiContainer4 = document.getElementById('einkommen');

if (ydiContainer4) {
  ReactDOM.render((
    <YouDrawItWidget
      chartId="zukunftsrauschen__einkommen"
      dataVisibleIndex={5}
      data={[
        { x: 2000, y: 17.002 },
        { x: 2001, y: 17.699 },
        { x: 2002, y: 17.684 },
        { x: 2003, y: 18.363 },
        { x: 2004, y: 18.783 },
        { x: 2005, y: 19.153 },
        { x: 2006, y: 19.602 },
        { x: 2007, y: 20.004 },
        { x: 2008, y: 20.741 },
        { x: 2009, y: 20.335 },
        { x: 2010, y: 20.930 },
        { x: 2011, y: 21.956 },
        { x: 2012, y: 22.309 },
        { x: 2013, y: 22.219 },
        { x: 2014, y: 22.884 },
        { x: 2015, y: 23.093 },
        { x: 2016, y: 23.646 }
      ]}
      xAxis={[2000, 2002, 2004, 2006, 2008, 2010, 2012, 2014, 2016]}
      yAxis={[0, 6, 12, 18, 24, 30, 36]}
      yDecimals={2}
      margin={{top: 0, right: 32, bottom: 0, left: 12}}
      linecolor="#EC6ED0"
      shareTitle="Einkommensentwicklung im Sauerland"
      onCompleted={() => {
        document.getElementById('youdrawit_answer-4').classList.add('active');
        trackProgress(4);
      }}
    />
  ), ydiContainer4);
}

const ydiContainer5 = document.getElementById('auslaender');

if (ydiContainer5) {
  ReactDOM.render((
    <YouDrawItWidget
      chartId="zukunftsrauschen__auslaender"
      dataVisibleIndex={5}
      data={[
        { x: 2000, y: 9.3 },
        { x: 2001, y: 8.8 },
        { x: 2002, y: 8.7 },
        { x: 2003, y: 8.7 },
        { x: 2004, y: 7.7 },
        { x: 2005, y: 7.7 },
        { x: 2006, y: 8.1 },
        { x: 2007, y: 8.0 },
        { x: 2008, y: 8.0 },
        { x: 2009, y: 7.9 },
        { x: 2010, y: 7.8 },
        { x: 2011, y: 8.1 },
        { x: 2012, y: 8.3 },
        { x: 2013, y: 8.6 },
        { x: 2014, y: 9.1 },
        { x: 2015, y: 9.8 },
        { x: 2016, y: 10.9 },
        { x: 2017, y: 11.2 }
      ]}
      xAxis={[2000, 2002, 2004, 2006, 2008, 2010, 2012, 2014, 2016, 2017]}
      yAxis={[0, 3, 6, 9, 12, 15]}
      yDecimals={1}
      margin={{top: 0, right: 12, bottom: 0, left: 12}}
      linecolor="#69A2FA"
      shareTitle="Ausländeranteil im Sauerland"
      onCompleted={() => {
        document.getElementById('youdrawit_answer-5').classList.add('active');
        trackProgress(5);
      }}
    />
  ), ydiContainer5);
}
